/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForDiscover.defs.js'
export * as $defs from './getSuggestedUsersForDiscover.defs.js'
